/**
 * Labstep
 *
 * @module prosemirror/nodes/metadata
 * @desc Metadata node
 */

import type { LabstepNode } from 'labstep-web/prosemirror/nodes/types';
import { getAttrsForId } from 'labstep-web/prosemirror/nodes/utils';
import type { Node as ProseMirrorNode } from 'prosemirror-model';

const key = 'metadata';

export const NodeMetadata: LabstepNode = {
  key,
  spec: {
    attrs: {
      id: {},
    },
    group: 'block',
    marks: '',
    parseDOM: [{ tag: 'div', getAttrs: getAttrsForId(key) }],
    toDOM(node: ProseMirrorNode) {
      const { id } = node.attrs;
      return ['div', { 'data-metadata-id': id }];
    },
  },
};
